import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../config/api";

export const fetchAllServices = createAsyncThunk(
    'services/fetch',
    async (params, { rejectWithValue }) => {
        const { offset, limit } = params;
        try {
            let resp = await axiosInstance.get(`/service?offset=${offset}&limit=${limit}`);
            if (resp?.data?.status == 200) {
                return resp?.data?.data?.services;
            } else {
                return rejectWithValue('Failed to fetch services')
            }
        } catch (error) {
            // return rejectWithValue(error.response?.data?.message || 'An error occurred')
            return rejectWithValue(error.response?.data?.message)
        }
    }
)

export const searchServices = createAsyncThunk(
    'services/search',
    async (params, { rejectWithValue }) => {
        const { subServices, lat, lng, radius } = params?.searchState;
        let subServicesParams = JSON.stringify(subServices);
        try {
            let resp = await axiosInstance.get(`/service/${params?.id}/service-provider`, {
                params: {
                    subServices: subServicesParams,
                    latitude: lat,
                    longitude: lng,
                    radius: radius,
                }
            });
            if (resp?.data?.status == 200) {
                return resp?.data?.data?.serviceProviders
            } else {
                return rejectWithValue('Failed to fetch service providers')
            }
        } catch (error) {
            // return rejectWithValue(error.response?.data?.message || 'An error occurred')
            return rejectWithValue(error.response?.data?.message)
        }
    }
)

const initialState = {
    loading: false,
    services: [],
    subServices: [],
    serviceProviders: [],
    listAndCardCurrentState: {},
    selectedFiltersIds: {},
    selectedService: [],
    serviceName: '',
    error: null
}

export const servicesSlice = createSlice({
    name: 'services',
    initialState,
    reducers: {
        getSubServices: (state, action) => {
            const { name, subServices } = action.payload;
            state.loading = false;
            state.subServices = Array.isArray(subServices) ? subServices : [subServices];
            state.serviceName = name
        },
        listAndCardStates: (state, action) => {
            state.listAndCardCurrentState = action.payload
        },
        listAndCardStatesClear: (state) => {
            state.listAndCardCurrentState = {}
        },
        selectedFiltersValue: (state, action) => {
            state.selectedFiltersIds = action.payload
        },
        selectedFiltersValueClear: (state) => {
            state.selectedFiltersIds = {}
        },
        setSelectedService: (state, action) => {
            state.selectedService = action.payload || []
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAllServices.pending, (state) => {
            state.loading = true
            state.services = []
            state.error = null
            state.subServices = []
            state.serviceName = ''
        });
        builder.addCase(fetchAllServices.fulfilled, (state, action) => {
            state.loading = false
            state.services = action.payload;
            state.error = null
            state.subServices = []
            state.serviceName = ''
        });
        builder.addCase(fetchAllServices.rejected, (state, action) => {
            state.loading = false
            state.services = []
            state.error = action.payload
            state.subServices = []
            state.serviceName = ''
        });
        builder.addCase(searchServices.pending, (state) => {
            state.loading = true;
            state.serviceProviders = [];
            state.error = null
        });
        builder.addCase(searchServices.fulfilled, (state, action) => {
            state.loading = false;
            state.serviceProviders = action.payload;
            state.error = null
        });
        builder.addCase(searchServices.rejected, (state, action) => {
            state.loading = false;
            state.serviceProviders = [];
            state.error = action.payload
        })
    }
})

export const { getSubServices, listAndCardStates, listAndCardStatesClear, selectedFiltersValue, selectedFiltersValueClear, setSelectedService } = servicesSlice.actions
export default servicesSlice.reducer